define('lq/events/actions/googleGeocodingQuery',[
    'underscore',
    'lq/events/actions/eventAction',
    'lq',
    'lq/events/abortError'
], function (_, EventAction, lq, AbortError) {
    'use strict';

    function GoogleGeocodingQuery(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
        this.eventData = eventData;

        return this;
    }

    EventAction.extend(GoogleGeocodingQuery, EventAction);

    GoogleGeocodingQuery.typeName = 'GoogleGeocodingQuery';

    GoogleGeocodingQuery.prototype.getBatchType = function () {
        return EventAction.DO_NOT_BATCH;
    };

    GoogleGeocodingQuery.prototype.execute = function (continuation) {

        require([
            'google_maps'
        ],
            this.main.bind(this, continuation)
        );

    };

    GoogleGeocodingQuery.prototype.forwardGeocoding = function (continuation, results, status) {
        if (status == google.maps.GeocoderStatus.OK) {
            this.setGeocodeValues(results);
            if (this.eventIsEnabled('succeeded')) {
                this.triggerEvent('succeeded', continuation);
            } else {
                continuation();
            }
        } else {
            if (this.eventIsEnabled('failed')) {
                this.triggerEvent('failed', continuation);
            } else {
                alert('The geocoding of the address has been failed, and the \'failed\' event is not enabled.')    
                continuation();
            }
        }
    };

    GoogleGeocodingQuery.prototype.main = function (continuation) {
        var geocoder = new google.maps.Geocoder();
        var address = this.piping.parameters.getValue(this.eventData.address);
        geocoder.geocode({ 'address': address }, this.forwardGeocoding.bind(this, continuation));
    }

    GoogleGeocodingQuery.prototype.setGeocodeValues = function (results) {
        var regex = /[(](-?[0-9]*.[0-9]*)[,][ ](-?[0-9]*.[0-9]*)[)]/;
        var result = regex.exec(results[0].geometry.location.toString());
        this.piping.parameters.locals.setValue(this.eventData.lat, result[1]);
        this.piping.parameters.locals.setValue(this.eventData.lng, result[2]);
    }

    return GoogleGeocodingQuery;
});
